import { createFileRoute } from "@tanstack/react-router"
import TasksAnalyticsPage from "@/components/coreAnalytics/tasks/TasksAnalyticsPage"

export const Route = createFileRoute("/core/analytics/tasks")({ component: TasksAnalyticsPage })
